/**
 * Me → Waitlist sub-page. Lists SOON SKUs the user has tapped "Notify me" on.
 */

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MeSubpageShell } from '../../components/chrome/MeSubpageShell';
import { EmptyState } from '../../components/me/EmptyState';
import { useMyWaitlist } from '../../hooks/useMyWaitlist';
import { useSkuLabel } from '../../lib/sku-i18n';
import styles from './MeSubpages.module.css';

export function Waitlist(): JSX.Element {
  const navigate = useNavigate();
  const { t } = useTranslation(['me', 'common']);
  const skuLabel = useSkuLabel();
  const { data, isLoading, isError } = useMyWaitlist();

  return (
    <MeSubpageShell title={t('sections.waitlist')} data-testid="waitlist-page">
      {isLoading && (
        <p className={styles.cardMeta} data-testid="waitlist-loading">
          {t('common:states.loading')}
        </p>
      )}
      {isError && (
        <p role="alert" data-testid="waitlist-error">
          {t('waitlist.loadError')}
        </p>
      )}
      {!isLoading && !isError && data && data.length === 0 && (
        <EmptyState
          title={t('waitlist.emptyTitle')}
          body={t('waitlist.emptyBody')}
          glyph="◌"
          ctaLabel={t('openHome')}
          onCta={() => void navigate('/home')}
          data-testid="waitlist-empty"
        />
      )}
      {!isLoading && !isError && data && data.length > 0 && (
        <div className={styles.list} data-testid="waitlist-list">
          {data.map((item) => (
            <button
              key={item.id}
              type="button"
              className={styles.card}
              onClick={() => void navigate(`/sku/${item.skuCode}`)}
              data-testid={`waitlist-${item.id}`}
            >
              <span className={styles.cardName}>{skuLabel(item.skuName)}</span>
              <span className={styles.cardMeta}>{item.notifyAt || t('common:states.comingSoon')}</span>
            </button>
          ))}
        </div>
      )}
    </MeSubpageShell>
  );
}
